export enum TipoTeste {
  ORGANIZACIONAL = 'organizacional',
  RECRUTAMENTO_E_SELECAO = 'recrutamento_e_selecao',
  DESENVOLVIMENTO_DE_COMPETENCIAS = 'desenvolvimento_de_competencias'
}

export const TipoTesteLabels: { [key in TipoTeste]: string } = {
  [TipoTeste.ORGANIZACIONAL]: 'Organizacional',
  [TipoTeste.RECRUTAMENTO_E_SELECAO]: 'Recrutamento e Seleção',
  [TipoTeste.DESENVOLVIMENTO_DE_COMPETENCIAS]: 'Desenvolvimento de Competências'
};
